import React, { useState } from "react";
import { useSelector } from "react-redux";
import TodayHeaderCard from "../components/today/TodayHeaderCard";
import TodayPersonalInputs from "../components/today/TodayPersonalInputs";
import TodayEntriesList from "../components/today/TodayEntriesList";
import TodayDialogs from "../components/today/TodayDialogs";

import { selectAllMeals, selectAllFoods } from "../store/selectors";

import { colors, space, radius, borders } from "../design/tokens";

import {
  Screen,
  Content,
  Card,
  TextInput,
  Button,
  Text,
  Row
} from "../components/layout";

export default function Today() {

  const entries = useSelector(state => state.today.entries);
  const meals = useSelector(selectAllMeals);
  const foodsById = useSelector(state => state.foods.byId);
  const foods = useSelector(selectAllFoods);


  const [openFoods, setOpenFoods] = useState(false);
  const [openMeals, setOpenMeals] = useState(false);
  const [openSingleFoods, setOpenSingleFoods] = useState(false);
  const [activeEntryId, setActiveEntryId] = useState(null);

  return (
    <>
        <Screen>
          <Content>
            <Card style={{
              padding: space.sm,
              gap: space.lg
            }}
            >
          <TodayHeaderCard />



          <TodayPersonalInputs />

          <Row flex={[1, 1]}>
            <Button slim onClick={()=>setOpenMeals(true)}>+ Add Meal</Button>
            <Button slim onClick={()=>setOpenSingleFoods(true)}>+ Add Food</Button>
          </Row>



          <TodayEntriesList
            entries={entries}
            meals={meals}
            foodsById={foodsById}
            foods={foods}
            onAddFood={(entryId) => {
              setActiveEntryId(entryId);
              setOpenFoods(true);
            }}
          />



          <TodayDialogs
            openFoods={openFoods}
            openMeals={openMeals}
            openSingleFoods={openSingleFoods}
            activeEntryId={activeEntryId}
            onCloseFoods={()=>setOpenFoods(false)}
            onCloseMeals={()=>setOpenMeals(false)}
            onCloseSingleFoods={()=>setOpenSingleFoods(false)}
          />
        </Card>
      </Content>
    </Screen>
    </>
  );
}